module.exports = __webpack_public_path__ + "img/male-child-foot.8ef81c21.svg";